import _Vue from "vue";
import ReportJobScheduler from "./jobScheduler";
export class PluginOptions { }

const JobSchedulerPlugin = {
    install(Vue: typeof _Vue, options?: PluginOptions) {
        let jobScheduler = new ReportJobScheduler();
        jobScheduler.start();
        Vue.prototype.$jobScheduler = jobScheduler
        console.log("JobSchedulerPlugin plugin is installing");
    }
};

export default JobSchedulerPlugin;
